import { render } from "./MoveToFolderModal.vue?vue&type=template&id=242cdb18&scoped=true&ts=true"
import script from "./MoveToFolderModal.vue?vue&type=script&lang=ts"
export * from "./MoveToFolderModal.vue?vue&type=script&lang=ts"

import "./MoveToFolderModal.vue?vue&type=style&index=0&id=242cdb18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242cdb18"]])

export default __exports__